import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=15486782&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./PhotoUpload.vue?vue&type=style&index=0&id=15486782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15486782",
  null
  
)

export default component.exports